'use strict';

module.exports = false;